import { ReactComponent as IconRadioEmpty } from "../assets/icons/radio-check-empty.svg";
import { ReactComponent as IconRadioSelected } from "../assets/icons/radio-check-selected.svg";
import "./CouponCard.css";

const CouponCard = ({ coupon, readOnly = false, onToggle }) => {
  const { code, label, description, enabled } = coupon;

  const handleClick = () => {
    if (!readOnly && onToggle) {
      onToggle(code);
    }
  };

  const handleKeyDown = (e) => {
    if (!readOnly && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      onToggle(code);
    }
  };

  return (
    <div
      className={`coupon-card${enabled ? " enabled" : " disabled"}${
        readOnly ? " read-only" : ""
      }`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="switch"
      aria-checked={enabled}
      tabIndex={readOnly ? -1 : 0}
    >
      <div className="coupon-toggle-icon">
        {enabled ? <IconRadioSelected /> : <IconRadioEmpty />}
      </div>
      <div className="coupon-content">
        <div className="coupon-code">{label}</div>
        {description && <div className="coupon-description">{description}</div>}
      </div>
    </div>
  );
};

export default CouponCard;
